import { motion } from "framer-motion";
import HotelMessageTemplate from "./HotelMessageTemplate";
import OfferMessageTemplate from "./OfferMessageTemplate";

export default function MessageTemplates({
  templates,
  assistantId,
  isMobile,
  threadId,
}: any) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      {templates.map((template: any, index: any) => {
        switch (template?.type) {
          case "hm_hotel":
            return (
              <HotelMessageTemplate
                key={index}
                template={template}
                index={index}
                assistantId={assistantId}
                isMobile={isMobile}
                threadId={threadId}
              />
            );
          case "hm_offer":
            return (
              <OfferMessageTemplate
                key={index}
                template={template}
                index={index}
                assistantId={assistantId}
                isMobile={isMobile}
                threadId={threadId}
              />
            );
          default:
            return null;
        }
      })}
    </motion.div>
  );
}
